<template>
	<select @change='change' :id='id' v-model="selected" class='form-control table-control my-control' data-num='f_20' data-table='1'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const LOCALFORESTRY = 'localforestrie_list.php'
	const HEADER = 'get_header.php'
	const ACT_LOCATION = 'get_act_location.php'

	import {EventBus} from '../../../lib/EventBus'
	
	export default {
		name: 'localforestry',
		data: function () {
			return {
				selected: '0',
				options: [],
				id: `${this.type}_localforestry_${this.line_count}`,
			}
		},
		props: {
			line_count: 0,
			type: '',
			f_id: '',
			lf_id: ''
		},
		methods: {
			change () {
				//console.warn(this.selected)
				EventBus.$emit(`${this.type}_localforestry_${this.line_count}`, this.selected)
				EventBus.$emit(`${this.type}_localforestry`, {index: this.line_count, value: this.selected})
			},
			fill (f_id, lf_id) {
				if(this.$parent.data_location.localforestry == null)
				{
					EventBus.$on('fetch_localforestry_complete', (data) => {
						if (data) {
							this.options = [{id: '0', name: ''}, ...data];
							this.selected = lf_id ? lf_id : '0'
						}
						else {
							this.options = []
							this.selected = '0'
						}
						EventBus.$off('fetch_localforestry_complete')
					})
				}
				else
				{
					let data = this.$parent.data_location.localforestry
					if (data) {
						this.options = [{id: '0', name: ''}, ...data];
						this.selected = lf_id ? lf_id : '0'
					}
					else {
						this.options = []
						this.selected = '0'
					}
				}
			}
		},
		created () {
			EventBus.$on(`${this.type}_forestry`, id => {
				this.fill(id)
			})

			/*var _this = this
			this.$nextTick(()=>{
					//this.fill(_this.$options._parentVnode.data.attrs.f_id, _this.$options._parentVnode.data.attrs.lf_id)
				console.log(_this.$options._parentVnode.data.attrs)
			})*/

			let f_id = this.$options.propsData.f_id
			let lf_id = this.$options.propsData.lf_id
			if (f_id)
				this.fill(f_id, lf_id)
			else
				this.fill(document.getElementById('edit_forestry').value)
			//console.log(this.$options.propsData)
		},
		beforeDestroy () {
			EventBus.$off(`${this.type}_forestry`)
			EventBus.$off('fetch_localforestry_complete')
		},
	}
</script>


// WEBPACK FOOTER //
// localforestry.vue?ed4f2d0c